// 챗봇 AI 진단 — farm_server 의 /api/diagnosis/* 엔드포인트.
// IIS/dev 프록시가 X-API-Key 를 자동 주입하므로 클라이언트는 헤더를 따로 붙이지 않는다.

import { baseUrl } from "api/baseUrl";

/**
 * 음성 파일 업로드 → STT → AI 진단을 한 번에 수행.
 * @param {Blob} audioBlob 녹음된 오디오 Blob
 * @param {string} [category] 장비 카테고리 (선택)
 */
export async function uploadAudioForDiagnosis(audioBlob, category) {
  const formData = new FormData();
  formData.append("audio", audioBlob, "recording.webm");
  if (category) formData.append("category", category);

  const res = await fetch(`${baseUrl}/diagnosis/upload-audio`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) throw new Error(`진단 서버 오류: ${res.status}`);
  return res.json();
}

/**
 * 텍스트 기반 AI 진단.
 * @param {string} text 고장 증상 텍스트
 * @param {string} [category] 장비 카테고리 (선택)
 */
export async function diagnoseAI(text, category) {
  const body = { text };
  if (category) body.category = category;

  const res = await fetch(`${baseUrl}/diagnosis/diagnose`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`진단 서버 오류: ${res.status}`);
  return res.json();
}
